module.exports = __webpack_public_path__ + "img/horizontal_7_2_8004.e810a11d.png";